import { render } from "./DeliveryInformation.vue?vue&type=template&id=58113ebe"
const script = {}

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__